<template>
  <Button v-if="isAuthenticated"
          type="secondary"
          @click="accountButtonRedirect">
    <template #icon>
      <Icon name="user-3-line"/>
    </template>
  </Button>
  <Button v-if="!isAuthenticated"
          type="secondary"
          @click="accountButtonRedirect">
    {{ t('buttons.log-in') }}
  </Button>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import Button from '@/components/partials/Buttons/Button/Button.vue'
import Icon from "@/components/partials/Icon.vue"
import { LOGIN_MODAL } from '@/types/Modals'
import { useLocalizedRouter } from '@/composables/localizedRouter'
import { useAuthStore } from '@/stores/useAuthStore'
import { useModalsStore } from '@/stores/useModalsStore'
import { storeToRefs } from "pinia"

const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const { localizedRoute } = useLocalizedRouter()
const { toggle } = useModalsStore()
const { isAuthenticated } = storeToRefs(authStore)

const accountButtonRedirect = async () => {
  if (!isAuthenticated.value) {
    return toggle(LOGIN_MODAL, true)
  }

  if (String(route.name).endsWith('customer-account-orders')) {
    return
  }

  await router.push(localizedRoute({ name: 'customer-account-orders' }))
}
</script>
